import { Injectable } from '@angular/core';

export interface INavigatePageInfo {
    navigateFrom: string;
    module: string;
    moduleIcon: string;
    pageTitle: string;
    linkArray: ILinkInfo[];
}

export interface ILinkInfo {
    moduleLink: string;
    linkTitle: string;
    showLink: boolean;
    isHome?: boolean;
    hideIf?: string[];
}

export interface IPageHeadline {
    module: string;
    moduleIcon: string;
    pageTitle: string;
    linkTitle?: string;
    moduleLink?: string;
    linkArray?: ILinkInfo[];
}

export interface IPageHeadlineDetails {
    module: string;
    moduleIcon: string;
    moduleId: string;
    pageTitle: string;
    linkArray: ILinkInfo[];
}

@Injectable({
    providedIn: 'root',
})
export class PageTitleParameters {
    constructor() {}

    pageHeadlines: IPageHeadlineDetails[] = [
        {
            module: 'report-menu',
            moduleId: 'leads-partners',
            moduleIcon: 'fa-table',
            pageTitle: '',
            linkArray: [
                {
                    moduleLink: 'leads-partners',
                    linkTitle: 'Leads & Partners Home',
                    showLink: true,
                    isHome: true,
                },
                {
                    moduleLink: 'leads-partners/at-a-glance',
                    linkTitle: 'Leads & Partners At a Glance',
                    hideIf: ['report-menu/leads-partners'],
                    showLink: true,
                },
                {
                    moduleLink: 'report-menu/leads-partners',
                    linkTitle: 'Leads & Partners Reports',
                    showLink: false,
                },
            ],
        },
        {
            module: 'report-menu',
            moduleIcon: 'fa-table',
            moduleId: 'report-menu',
            pageTitle: '',
            linkArray: [
                {
                    moduleLink: 'report-menu',
                    linkTitle: 'Reports Home',
                    showLink: true,
                    isHome: true,
                },
            ],
        },
        {
            module: 'report-menu',
            moduleIcon: 'fa-table',
            moduleId: 'financials',
            pageTitle: '',
            linkArray: [
                {
                    moduleLink: 'financials',
                    linkTitle: 'Financials Home',
                    showLink: true,
                    isHome: true,
                },
                {
                    moduleLink: 'financials/at-a-glance',
                    linkTitle: 'Financials At a Glance',
                    hideIf: [
                        'report-menu/financials',
                        'financials/insights/incentives',
                        'financials/insights/profitability',
                    ],
                    showLink: true,
                },
                {
                    moduleLink: 'report-menu/financials',
                    linkTitle: 'Financials Reports',
                    showLink: false,
                },
                {
                    moduleLink: 'financials/insights/profitability',
                    linkTitle: 'Loan Profitability',
                    hideIf: ['report-menu/financials', 'financials/at-a-glance'],
                    showLink: false,
                },
                {
                    moduleLink: 'financials/insights/incentives',
                    linkTitle: 'Incentives',
                    hideIf: ['report-menu/financials', 'financials/at-a-glance'],
                    showLink: false,
                },
                {
                    moduleLink: 'financials/insights/revenue-trends',
                    linkTitle: 'Loan Profitability',
                    hideIf: ['report-menu/financials', 'financials/at-a-glance'],
                    showLink: false,
                },
            ],
        },
        {
            module: 'report-menu',
            moduleIcon: 'fa-table',
            moduleId: 'historical-trends',
            pageTitle: '',
            linkArray: [
                {
                    moduleLink: 'historical-trends',
                    linkTitle: 'Historical Trends Home',
                    showLink: true,
                    isHome: true,
                },
                {
                    moduleLink: 'historical-trends/at-a-glance',
                    linkTitle: 'Historical Trends At a Glance',
                    hideIf: [
                        'report-menu/historical-trends',
                        'historical-trends/insights/headcount-trends',
                    ],
                    showLink: true,
                },
                {
                    moduleLink: 'historical-trends/insights/headcount-trends',
                    linkTitle: 'Headcount Trends',
                    hideIf: ['report-menu/historical-trends', 'historical-trends/at-a-glance'],
                    showLink: false,
                },
                {
                    moduleLink: 'report-menu/historical-trends',
                    linkTitle: 'Historical Trends Reports',
                    showLink: false,
                },
            ],
        },
        {
            module: 'report-menu',
            moduleIcon: 'fa-table',
            moduleId: 'production',
            pageTitle: '',
            linkArray: [
                {
                    moduleLink: 'production',
                    linkTitle: 'Production Home',
                    showLink: true,
                    isHome: true,
                },
                {
                    moduleLink: 'production/at-a-glance',
                    linkTitle: 'Production At a Glance',
                    hideIf: [
                        'report-menu/production',
                        'production/insights/funded-product-distribution',
                        'production/insights/production-turn-times',
                        'production/insights/funded-loan-characteristics',
                        'production/insights/funded-borrower-characteristics',
                        'production/insights/milestone-utilization',
                        'production/insights/eclose-roi-trends',
                        'production/insights/eclose-adoption-trends',
                        'production/insights/production-loan-category-distribution',
                    ],
                    showLink: true,
                },
                {
                    moduleLink: 'production/insights/funded-product-distribution',
                    linkTitle: 'Funded Loan Product Distribution',
                    hideIf: [
                        'report-menu/production',
                        'production/at-a-glance',
                        'production/insights/production-turn-times',
                    ],
                    showLink: false,
                },
                {
                    moduleLink: 'production/insights/production-turn-times',
                    linkTitle: 'Production Turn Times',
                    hideIf: [
                        'report-menu/production',
                        'production/at-a-glance',
                        'production/insights/funded-product-distribution',
                    ],
                    showLink: false,
                },
                {
                    moduleLink: 'report-menu/production',
                    linkTitle: 'Production Reports',
                    showLink: false,
                },
                {
                    moduleLink: 'production/insights/funded-loan-characteristics',
                    linkTitle: 'Funded Loan Characteristics',
                    hideIf: ['report-menu/production', 'production/at-a-glance'],
                    showLink: false,
                },
                {
                    moduleLink: 'production/insights/funded-borrower-characteristics',
                    linkTitle: 'Funded Borrower Characteristics',
                    hideIf: ['report-menu/production', 'production/at-a-glance'],
                    showLink: false,
                },
                {
                    moduleLink: 'production/insights/milestone-utilization',
                    linkTitle: 'Milestone Utilization',
                    hideIf: ['report-menu/production', 'production/at-a-glance'],
                    showLink: false,
                },
                {
                    moduleLink: 'production/insights/eclose-roi-trends',
                    linkTitle: 'eClose ROI Trends',
                    hideIf: ['report-menu/production', 'production/at-a-glance'],
                    showLink: false,
                },
                {
                    moduleLink: 'production/insights/eclose-adoption-trends',
                    linkTitle: 'eClose Adoption Trends',
                    hideIf: ['report-menu/production', 'production/at-a-glance'],
                    showLink: false,
                },
                {
                    moduleLink: 'production/insights/production-loan-category-distribution',
                    linkTitle: 'Funded Loan Category Distribution',
                    hideIf: ['report-menu/production', 'production/at-a-glance'],
                    showLink: false,
                },
            ],
        },
        {
            module: 'report-menu',
            moduleIcon: 'fa-table',
            moduleId: 'pipeline',
            pageTitle: '',
            linkArray: [
                {
                    moduleLink: 'pipeline',
                    linkTitle: 'Pipeline Home',
                    showLink: true,
                    isHome: true,
                },
                {
                    moduleLink: 'pipeline/at-a-glance',
                    linkTitle: 'Pipeline At a Glance',
                    hideIf: [
                        'report-menu/pipeline',
                        'pipeline/activity-tracker',
                        'pipeline/insights/milestone-status',
                        'pipeline/insights/sales-funnel',
                        'pipeline/insights/pipeline-with-position-assigned',
                        'pipeline/insights/loan-characteristics',
                        'pipeline/insights/borrower-characteristics',
                        'pipeline/insights/operations-assignments',
                        'pipeline/insights/operations-pipeline',
                        'pipeline/insights/pipeline-trends',
                        'pipeline/insights/loan-category-distribution',
                        'pipeline/insights/product-distribution',
                    ],
                    showLink: true,
                },
                {
                    moduleLink: 'pipeline/activity-tracker',
                    linkTitle: 'Pipeline Activity',
                    hideIf: [
                        'report-menu/pipeline',
                        'pipeline/at-a-glance',
                        'pipeline/insights/milestone-status',
                    ],
                    showLink: false,
                },
                {
                    moduleLink: 'pipeline/insights/milestone-status',
                    linkTitle: 'Loan Pipeline Lock Status Insights',
                    hideIf: [
                        'report-menu/pipeline',
                        'pipeline/at-a-glance',
                        'pipeline/activity-tracker',
                    ],
                    showLink: false,
                },
                {
                    moduleLink: 'report-menu/pipeline',
                    linkTitle: 'Pipeline Reports',
                    showLink: false,
                },
                {
                    moduleLink: 'pipeline/insights/sales-funnel',
                    linkTitle: 'Sales Pipeline Funnel',
                    hideIf: [
                        'report-menu/pipeline',
                        'pipeline/at-a-glance',
                        'pipeline/activity-tracker',
                    ],
                    showLink: false,
                },
                {
                    moduleLink: 'pipeline/insights/pipeline-with-position-assigned',
                    linkTitle: 'Upcoming Closings',
                    hideIf: [
                        'report-menu/pipeline',
                        'pipeline/at-a-glance',
                        'pipeline/activity-tracker',
                    ],
                    showLink: false,
                },
                {
                    moduleLink: 'pipeline/insights/pipeline-trends',
                    linkTitle: 'Pipeline Trends',
                    hideIf: [
                        'report-menu/pipeline',
                        'pipeline/at-a-glance',
                        'pipeline/activity-tracker',
                    ],
                    showLink: false,
                },
                {
                    moduleLink: 'pipeline/insights/loan-characteristics',
                    linkTitle: 'Pipeline Loan Characteristics',
                    hideIf: ['report-menu/pipeline', 'pipeline/at-a-glance'],
                    showLink: false,
                },
                {
                    moduleLink: 'pipeline/insights/borrower-characteristics',
                    linkTitle: 'Pipeline Borrower Characteristics',
                    hideIf: ['report-menu/pipeline', 'pipeline/at-a-glance'],
                    showLink: false,
                },
                {
                    moduleLink: 'pipeline/insights/operations-assignments',
                    linkTitle: 'Operations Assignments',
                    hideIf: ['report-menu/pipeline', 'pipeline/at-a-glance'],
                    showLink: false,
                },
                {
                    moduleLink: 'pipeline/insights/operations-pipeline',
                    linkTitle: 'Operations Pipeline',
                    hideIf: ['report-menu/pipeline', 'pipeline/at-a-glance'],
                    showLink: false,
                },
                // {
                //     moduleLink: 'pipeline/insights/pipeline-trends',
                //     linkTitle: 'Pipeline Trends',
                //     hideIf: ['report-menu/pipeline', 'pipeline/at-a-glance'],
                //     showLink: false,
                // },
                {
                    moduleLink: 'pipeline/insights/loan-category-distribution',
                    linkTitle: 'Active Pipeline Loan Category Distribution',
                    hideIf: ['report-menu/pipeline', 'pipeline/at-a-glance'],
                    showLink: false,
                },
                {
                    moduleLink: 'pipeline/insights/product-distribution',
                    linkTitle: 'Active Pipeline Product Distribution',
                    hideIf: ['report-menu/pipeline', 'pipeline/at-a-glance'],
                    showLink: false,
                },
            ],
        },
        {
            module: 'report-menu',
            moduleIcon: 'fa-table',
            moduleId: 'performance',
            pageTitle: '',
            linkArray: [
                {
                    moduleLink: 'performance',
                    linkTitle: 'Performance Home',
                    showLink: true,
                    isHome: true,
                },
                {
                    moduleLink: 'performance/at-a-glance',
                    linkTitle: 'Performance At a Glance',
                    hideIf: ['report-menu/performance'],
                    showLink: true,
                },
                {
                    moduleLink: 'report-menu/performance',
                    linkTitle: 'Performance Reports',
                    showLink: false,
                },
            ],
        },
        {
            module: 'report-menu',
            moduleIcon: 'fa-table',
            moduleId: 'directory',
            pageTitle: '',
            linkArray: [
                {
                    moduleLink: 'directory',
                    linkTitle: 'Directory',
                    showLink: true,
                    isHome: true,
                },
            ],
        },
        {
            module: 'report-menu',
            moduleIcon: 'fa-table',
            moduleId: 'my-vision',
            pageTitle: '',
            linkArray: [
                {
                    moduleLink: 'my-vision',
                    linkTitle: 'My Vision Home',
                    showLink: true,
                    isHome: true,
                },
                {
                    moduleLink: 'my-vision/corporate-dashboard',
                    linkTitle: 'Corporate Dashboard',
                    hideIf: ['my-vision/my-dashboard'],
                    showLink: true,
                },
                {
                    moduleLink: 'my-vision/my-dashboard',
                    linkTitle: 'My Dashboard',
                    hideIf: ['my-vision/corporate-dashboard'],
                    showLink: true,
                },
            ],
        },
    ];
}
